import React, { Component } from 'react';
import axios from 'axios';
import './SignIn.scss';

export default class RequestAccountSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      error: false,
      loading: true
    };
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    if (email && !this.state.submitted) {
      this.setState({ submitted: true });

      axios
        .post(
          process.env.REACT_APP_GD2_URL + '/portal_apis/clients/account/request_portal_creation',
          {
            email: email
          },
          {
            headers: {
              'FORTIS-API-ACCOUNT-TYPE': 'client-portal',
              'Content-Type': 'application/json'
            }
          }
        )
        .then(() => {
          this.setState({ loading: false });
        })
        .catch(err => {
          this.setState({ error: true, loading: false });
        });
    }
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="sign-in content-above-footer">
          <div className="main-content">
            <div className="page-header u-center-text">Processing Request</div>
            <div className="card">
              <div style={{ textAlign: 'center', padding: '40px' }}>
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #444b68',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                  }}
                ></div>
                <p style={{ color: '#7c8195', fontSize: '16px' }}>Please wait while we process your request...</p>
              </div>
            </div>
          </div>
          <style jsx>{`
            @keyframes spin {
              0% {
                transform: rotate(0deg);
              }
              100% {
                transform: rotate(360deg);
              }
            }
          `}</style>
        </div>
      );
    }

    return (
      <div className="sign-in content-above-footer">
        <div className="main-content">
          <div className="page-header u-center-text">{this.state.error ? 'Request Failed' : 'Request Received'}</div>
          <div className="card">
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <h3 style={{ color: '#444b68', marginBottom: '20px' }}>Thank You!</h3>
              {!this.state.error && (
                <p style={{ color: '#7c8195', lineHeight: '1.5', fontSize: '16px' }}>
                  Your request has been received and you will be contacted with your login details.
                </p>
              )}
              {this.state.error && (
                <p style={{ color: '#e74c3c', marginTop: '15px' }}>
                  There was an issue submitting your request. Please try again later.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
